import { IdConta, IdEtiqueta, IdInbox } from "../common-types";
import { GenericService } from "../generic-service";

export type CreateEtiqueta = {
    nome     : string,
    cor      : string,
    descricao: string,
    idInbox? : IdInbox | null,
    idConta? : IdConta | null,
}

export type UpdateEtiqueta = Partial<CreateEtiqueta> & { id: IdEtiqueta }

export type ResponseEtiqueta = {
    id       : IdEtiqueta;
    codigo?  : string,      // código sequencial legível (BigInt serializado como string)
    nome     : string,
    cor      : string,
    descricao: string,      
    del: boolean,      
    idInbox? : IdInbox | null,
}

export class EtiquetaService extends GenericService<CreateEtiqueta, UpdateEtiqueta, ResponseEtiqueta> {
    constructor() { super('etiquetas') }
    async getByIdWithoutRedirect(idEtiqueta: IdEtiqueta) {
        return await this.f.get(`/${idEtiqueta}`, undefined, {doNotRedirectOn401: true})
    }
    async getManyById(idEtiqueta: IdEtiqueta[]) {
        const unique = Array.from(new Set(idEtiqueta));
        const promiseArray = unique.map(id => this.getById(id));
        const results = await Promise.all(promiseArray);
        return results.filter(tag => !!tag);
    }
    async getAllByConta(idConta: IdConta): Promise<ResponseEtiqueta[]> {
        try {
            return await this.f.get(`/?idConta=${idConta}`) as ResponseEtiqueta[];
        } catch (e) {
            console.error(e);

            return [];
        }
    }
}